import i18n from "@/i18n.ts";
import { ApiFormScaleType } from "@/types/forms/form-scale.types.ts";
import { SurveyStatusItem } from "@/types/survey.types.ts";
import { SelectItem } from "@skailer-com/uikit";
import { ApiCustomFieldValue, ApiFieldTypes } from "@/types/custom-field.types.ts";
import { ApiFile } from "@/types/common.types.ts";
import {
  ApiEmployeeCompensationPerTypes,
  CompensationComponentRateTypes,
} from "@/types/employees/employee-compensation.types.ts";

export enum ApiFormType {
  survey = "survey",
  scoreCard = "scoreCard",
  performanceReview = "performanceReview",
}

export enum ApiFormElementType {
  scale = "scale",
  open_answer = "open_answer",
  employee_nps = "employee_nps",
  select = "select",
  goals = "goals",
  file = "file",

  text = "text",
  write_to_field = "write_to_field",
}

export type FormScaleTypeItem = SelectItem;
export const FormScaleTypeItems = () => {
  return [
    {
      id: ApiFormScaleType.single_scale,
      title: i18n.t("surveys:scale_type_single_scale"),
    },
    {
      id: ApiFormScaleType.double_scale,
      title: i18n.t("surveys:scale_type_double_scale"),
    },
  ] as FormScaleTypeItem[];
};

export interface ApiFormResultAnswer {
  form_element_id: number;
  comment?: string;
  answer_text?: string;
  answer_int?: number;
  answer_scale_option_ids?: number[];
  answer_select_option_ids?: number[];
  reference_id?: number;
  answer_write_to_field?: ApiFormResultWriteToFieldRow[];
  answer_file_uuids?: string[];
  answer_files?: ApiFile[];
}

export interface ApiFormResultWriteToFieldRow {
  cells: ApiFormResultWriteToFieldCell[] | null;
  target_row_id: number | null;
  date_effective_from: Date | null;
}

export interface ApiFormResultWriteToFieldCell {
  field_id: number;
  field_type: ApiFieldTypes;
  value: ApiCustomFieldValue;
  value_compensation_lines?: ApiFormResultCompensationLine[] | null;
}

export interface ApiFormResultCompensationLine {
  id?: number | null;
  compensation_component_id: number;
  amount_gross: string | number | null;
  amount_net: string | number | null;
  currency_code: string | null;
  per_type: ApiEmployeeCompensationPerTypes | null;
  sort: number | null;
  description: string | null;
  rate_type: CompensationComponentRateTypes | null;
  percent: string | number | null;
}

export interface ApiFormResultAnswerAnonymous {
  comment?: string;
  answer_text?: string;
  answer_int?: number;
  answer_scale_option_ids?: number[];
  answer_select_option_ids?: number[];
  answer_files?: ApiFile[];
}

export interface ApiFormShort {
  id: number;
}

export enum ApiFormParticipantStatus {
  added = "added",
  invited = "invited",
  in_progress = "in_progress",
  completed = "completed",
  canceled = "canceled",
}

export const FormParticipantStatusItems = () => {
  return [
    {
      id: ApiFormParticipantStatus.added,
      title: i18n.t("surveys:participant_status_added"),
    },
    {
      id: ApiFormParticipantStatus.invited,
      title: i18n.t("surveys:participant_status_invited"),
    },
    {
      id: ApiFormParticipantStatus.in_progress,
      title: i18n.t("surveys:participant_status_in_progress"),
    },
    {
      id: ApiFormParticipantStatus.completed,
      title: i18n.t("surveys:participant_status_completed"),
    },
    {
      id: ApiFormParticipantStatus.canceled,
      title: i18n.t("surveys:participant_status_canceled"),
    },
  ] as SurveyStatusItem[];
};

export enum ApiFormScoreMark {
  none = "none",
  low = "low",
  average = "average",
  high = "high",
}

export const scoreMarkColors = {
  [ApiFormScoreMark.none]: "secondary",
  [ApiFormScoreMark.low]: "bg-danger",
  [ApiFormScoreMark.average]: "bg-warning",
  [ApiFormScoreMark.high]: "bg-positive",
};
